<template>
  <el-row :gutter="24">
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-col :span="4">
      <el-select v-model="SeciliDonem" @change="Getir()" placeholder="Dönem Seçiniz" filterable>
        <el-option
          v-for="item in DonemListe"
          :label="item.aciklama"
          :value="item.id">
        </el-option>
      </el-select>
      <hr v-if="Hesap_id==6">

      <el-button v-if="Hesap_id==6" type="primary" class="btn-block" size="small" @click="YeniTalepModal=true">JetUsta
        Talep Ekle
      </el-button>

      <div v-if="Hesap_id==6" class="scrollkaydir" style="height: 300px">
        <table class=" table tablebordered table-xs ">
          <thead>
          <tr>
            <th>
              TALEPLER
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="y in JuTalep" @click="Secili=y" style="cursor:pointer;">
            <td>
              <small class="d-block">
                Açıklama
              </small>
              {{ y.Aciklama }}
              <small class="d-block">
                Tarih - Durum
              </small>
              {{ y.tarih }} - {{ y.DurumText }}
            </td>
          </tr>
          <tr v-if="!JuTalep">
            <td>
              Talep Yok
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <JuTalepDetay :data="Secili" v-if="Secili" @Kapat="Secili=null"></JuTalepDetay>


      <juYeniTalep v-if="YeniTalepModal" @Kapat="YeniTalepModal=false" :AboneNo="Abone_id"
                   :AdSoyad="MeskenListesi.AdSoyad" :Adres="Adres" Hizmet_id="165"></juYeniTalep>
      <hr>
      <Notlar :data="Notlars"></Notlar>

    </el-col>
    <el-col :span="5">
      <el-alert
        :closable="false"
        v-if="!SeciliDonem"
        title="Dönem Seçiniz"
        type="error">
      </el-alert>
      <AboneLazerDokumu v-if="SeciliDonem" :f="MeskenListesi" :Fatura="AskiListesi.Fatura"
                        :AltToplam="AskiListesi.AltToplam"></AboneLazerDokumu>
    </el-col>
    <el-col :span="15">
      <el-alert
        :closable="false"
        title="Dönem Seçiniz"
        v-if="!SeciliDonem"
        type="error">
      </el-alert>
      <div class="scrollkaydiryx" :style="'height: '+Height+'px'">
        <BinaHesaplamaDokumu  :Hesap_id="Hesap_id" v-if="SeciliDonem" :Fatura="AskiListesi.Fatura"
                              :AltToplam="AskiListesi.AltToplam"
                              :FaturaDokum="AskiListesi.FaturaDokum"></BinaHesaplamaDokumu>
      </div>
    </el-col>

  </el-row>
</template>

<script>
import Notlar from "../../../components/Pack/Genel/Notlar";
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import SayacAskiListesi from "../../../components/Pack/Esayac/SayacAskiListesi";
import AboneLazerDokumu from "./AboneLazerDokumu";
import JuYeniTalep from "../../JetUsta/Comp/juYeniTalep";
import JuTalepDetay from "../../JetUsta/Comp/juTalepDetay";
import BinaHesaplamaDokumu from "../../../components/Pack/Esayac/BinaHesaplamaDokumu";

export default {
  components: {BinaHesaplamaDokumu, JuTalepDetay, JuYeniTalep, AboneLazerDokumu, SayacAskiListesi, Yukleniyor, Notlar},
  props: ['Abone_id'],
  data() {
    return {
      Secili: null,
      Adres: '',
      Height: window.innerHeight - 130,
      lo: false,
      YeniTalepModal: false,
      DonemListe: null,
      Hesap_id: null,
      SeciliDonem: null,
      MeskenBilgi: null,
      Sayaclar: null,
      MeskenListesi: null,
      AskiListesi: null,
      search: '',
      Notlars: {
        Modul: 's_Mesken',
        Modul_id: this.Abone_id
      },

    }
  },
  methods: {
    TalepAc() {
    },
    Getir() {

      // this.SeciliDonem = Donemid;

      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/abone/donem/' + this.Abone_id + '/' + this.SeciliDonem})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.MeskenListesi = response.MeskenListesi;
            this.AskiListesi = response.AskiListesi;
            this.Adres = this.AskiListesi.Fatura.BinaAdi + ' ' + this.MeskenBilgi.kNo + ' NOLU MESKEN'
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    SayfaYukle() {
      this.Hesap_id = JSON.parse(localStorage.getItem('_aiHesap'))['id'];
      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/abone/detay/' + this.Abone_id})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.DonemListe = response.DonemListe;
            this.MeskenBilgi = response.MeskenBilgi;
            this.Sayaclar = response.Sayaclar;
            this.JuTalep = response.JuTalep;
            this.SeciliDonem = response.SonDonem;
            if (this.SeciliDonem) this.Getir();
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  },
  created() {
    this.SayfaYukle()

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Abone/AboneDetay.vue